import React from "react";
import ReactDom from "react-dom";
import PropTypes from "prop-types";
import ReactSelect from "react-select-v1";
import { If } from "../utils/FormFunctions";

export default class SelectBox extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this._handleChange.bind(this);
  }

  _handleChange(selected_option) {
    if (selected_option === null) {
      this.props.onChangeValue(
        { [this.props.name]: this.props.initial_value || "" },
        this.props.id,
        this.props.add_option || null
      );
      return;
    }
    const value = this.props.multi
      ? selected_option.split(",")
      : selected_option.value;
    const diff_value = this.props.add_option ? value.split(",")[0] : value;
    const key_value =
      this.props.value != diff_value ? { [this.props.name]: value } : null;
    if (key_value) {
      this.props.onChangeValue(
        key_value,
        this.props.id,
        this.props.add_option || null
      );
    }
  }

  render() {
    let value = this.props.multi
      ? this.props.value
        ? this.props.value.join(",")
        : []
      : this.props.value;
    value = this.props.add_option
      ? `${value},${this.props.additional_value}`
      : value;

    const items =
      this.props.multi &&
      this.props.limit &&
      this.props.value.length == this.props.limit
        ? this.props.items.filter((i, idx) =>
            this.props.value.includes(i.value)
          )
        : this.props.items;

    return (
      <ReactSelect
        name={this.props.name}
        value={value}
        options={items}
        placeholder={this.props.placeholder || "選択してください"}
        onChange={this.handleChange}
        optionRenderer={this.props.renderValue || this.renderValue}
        valueRenderer={this.props.renderSelectedValue || this.props.renderValue}
        clearable={this.props.clearable || false}
        disabled={this.props.disabled}
        className={this.props.className}
        multi={this.props.multi || false}
        matchPos={this.props.matchPos || "any"}
        matchProp={this.props.matchProp || "any"}
        simpleValue={this.props.multi || false}
        required={this.props.required}
        noResultsText={this.props.noResultsText || "見つかりません"}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
      />
    );
  }
}

SelectBox.defaultProps = {
  renderValue: (option) => (
    <span className={`selectIcon is${option.value}`}>{option.label}</span>
  ),
};

SelectBox.propTypes = {
  name: PropTypes.string.isRequired,
  onChangeValue: PropTypes.func.isRequired,
};
